import { gql } from "@apollo/client";

export const getUserAllViewQuery = gql`
query($objectType: String!, $userId: String!){
  getUserAllViewList(objectType: $objectType, userId: $userId) {
    message
    response
  }
}
`;